<div class="parcel-table-wrapper">
  <div class="parcel-table-shell">
    <!-- Added by Amisha on 2026-06-26 to mirror the Janus data-table overlay frame behavior for parcel notes.
         Reason: fixed pagination and internal table scroll must turn off while the notes overlay is open so the paginator does not show behind the modal. -->
    <wm-common-table [columns]="columns" [data]="results" tableType="Staff" [defaultPageSize]="pageSize"
      [pageSize]="pageSize" [pageSizeOptions]="[20,40,60,100]" [showRowsPerPage]="false" [isLoading]="isLoading"
      [serverSidePagination]="true" [totalPages]="totalPages" [currentPage]="currentPage"
      [fixedPagination]="isParcelNotesOverlayOpen ? false : true"
      [enableTableScroll]="isParcelNotesOverlayOpen ? false : true"
      (pageChange)="onPageChange($event)" (rowsPerPageChange)="onRowsPerPageChange($event)"
      (rowCheckboxClick)="onRowToggle($event)" (headerCheckboxClick)="onHeaderToggle($event)"  (sortChanged)="onSortChange($event)">
    </wm-common-table>
  </div>

  <!-- Added by Amisha on 2026-06-26 to always clear the overlay state when parcel notes close.
       Reason: the parcels table must restore its fixed frame after the Janus notes modal is dismissed. -->
  <wm-modal-confirm class="parcel-tab-notes-modal" title="Parcel Notes" [small]="false" [showButtonText]="false"
    [showButton]="false" commandText="Save"
    (accepted)="notesModal(publicNote, internalNote, selectedParcelForNotes?.parcelID)"
    (canceled)="onParcelNotesClosed()"
    (opened)="getParcelNote(selectedParcelForNotes?.parcelID)" [showCommandButton]="canManageParcelNotes"
    [janusStyling]="true" [isJanusMobileview]="true" janusModalWidth="640px" #ParcelNotesModal>
    <div class="mb-3">
      <strong>{{ selectedParcelForNotes?.parcelID }}</strong>
    </div>
    <div class="textarea-div1">
      <wm-common-textfield [data]="{
      label: 'Public Note',
      textAreaRows: 4,
      type: 'text-area',
      id: 'publicNote',
      readonly: !canManageParcelNotes,
    }" [(ngModel)]="publicNote">
      </wm-common-textfield>
    </div>

    <div class="textarea-div2">
      <wm-common-textfield *ngIf="canViewInternalParcelNotes" [data]="{
      label: 'Internal Note',
      textAreaRows: 4,
      type: 'text-area',
      readonly: !canManageParcelNotes
    }" [(ngModel)]="internalNote">
      </wm-common-textfield>
    </div>

  </wm-modal-confirm>
</div>
